<ng-container *ngIf="requestData">
    <h4 class="header">My request</h4>

    <div class="how-it-work">
        <p><strong>How it works?</strong></p>
        <ol>
            <li><strong>Select reason</strong> from the request reason list.</li>
            <li>Change <strong>delivery location</strong> if needed. The default location is your home office.</li>
            <li>Click the <strong>“Next” button</strong> in the bottom right corner.</li>
        </ol>
    </div>
    <ng-container *ngTemplateOutlet="requestData.badgeRequestType === badgeRequestTypeEnum.Resubmission ? resubmitPhoto : default"></ng-container>

    <div class="tabs align-items-center">
        <ng-container *ngFor="let tab of tabs; let last = last">

            <div class="tab-break" *ngIf="last"></div>

            <div class="tab"
                [class.active]="tab.reasonId===requestReasonPayload.reason"
                [class.photo-update-tile]="tab.reasonId===badgeChangeReasonsCategories.PhotoUpdate"
                (click)="pickRequestReason(tab)"
                (keydown.enter)="pickRequestReason(tab)"
                tabindex="0"
                role="button">
                <img [src]="tab.icon" alt="{{ tab.name }}">
                <div class="tab__info">
                    <div class="tab__info--caption">{{ tab.name }}</div>
                    <div class="tab__info--count">{{ tab.placeholder }}</div>
                </div>
            </div>
        </ng-container>
    </div>

    <div *ngIf="isNoteBlockShown" class="note-block">
        <div class="note-block__icon">
            <i class="icon-info"></i>
        </div>
        <div class="note-block__title">
            <ng-container [ngSwitch]="requestReasonPayload.reason">
                <ng-container *ngSwitchCase="badgeChangeReasonsCategories.BadgeLost">
                    <span>Please, if you find your lost badge, bring it to One Team.</span>
                </ng-container>
                <ng-container *ngSwitchCase="badgeChangeReasonsCategories.BadgeStolen">
                    <span>Please, if you find your stolen badge, bring it to One Team.</span>
                </ng-container>
                <ng-container *ngSwitchCase="badgeChangeReasonsCategories.BadgeDamaged">
                    <span>Please, return your damaged badge to One Team.</span>
                </ng-container>
            </ng-container>
        </div>
    </div>

    <ng-container>
        <div><b>Employee name</b></div>
        <div>{{requestData.userFullname}}</div>
    </ng-container>
    <ng-template #preferredFullName>
        <div class="preferred-name">
            <b>Preferred name</b>
            <span>Choose one of the proposed variants which will be displayed on a badge</span>
            <label class="pt-2 pb-1">
                <input
                    type="radio"
                    id="fullname"
                    name="fullname"
                    [value]="requestData.userFullname"
                    (change)="onChangeName(false)"
                    [checked]="isFullNameChecked">
                <span></span> {{requestData.userFullname}}
            </label>
            <label>
                <input
                    type="radio"
                    id="preferredFullName"
                    name="fullname"
                    [value]="requestData.preferredFullname"
                    (change)="onChangeName(true)"
                    [checked]="!isFullNameChecked">
                <span></span> {{requestData.preferredFullname}}
            </label>
        </div>
    </ng-template>

    <div class="details-block">
        <div class="delivery-location">
            <b>Delivery location</b>
            <div>
                <span class="delivery-location__title">
                    Deloitte location where badge can be picked up
                </span>

                <ui-searchable-dropdown
                    keyName="siteId"
                    valueName="siteName"
                    dropdownValueName="siteName"
                    placeholderText="Select Location"
                    [dataList]="requestData.sites"
                    [isSiteDropdown]="false"
                    [currentValue]="requestReasonPayload.deliverySiteName"
                    [dataFilterConfig]="locationFilterConfig"
                    [optionsWidth]="320"
                    (onSelect)="locationChanged($event)"
                    >
                </ui-searchable-dropdown>
            </div>
        </div>
    </div>

</ng-container>

<ng-template #default>
    <div class="warning-block">
        <i class="icon-exclamation_mark_circled"></i>
        <span>This application should not be used for request of a temporary badge.</span>
    </div>

    <div><b>Select reason for request</b></div>
</ng-template>

<ng-template #resubmitPhoto>
    <div class="warning-block resubmit-photo">
        <i class="icon-info"></i>
        <span>Please recheck the request details below, update it if needed and click the “Next”<br>
            button in the right bottom corner to continue.
        </span>
    </div>

    <div><b>Badge request reason</b></div>
</ng-template>
